import RegisterDist from './RegisterDist';

export default RegisterDist;
